<!-- src/components/LoginForm.vue -->
<template>
<div>
  <div class="form-container">
  <form @submit.prevent="forgot" class="login-form">
    <h2>Type in your email</h2>

    <div class="top-text"><p>Forgot Password? No worries, we will send
       a link to reset your password</p></div>
    <input type="email" placeholder="Email" v-model="email" required />

 
   

    <button class="submit-button" type="submit">Send Link</button>
    <p>Already have an account? <router-link to="/login/" class="hyper-link">Log in</router-link></p>

  </form>
  <h2 v-show="messa">Link sent to your email</h2>
  </div>
</div>
</template>

<script>

import { supabase } from '@/supabase.js'

export default {


  data() {
    return {
      email: '',
      messa:false
    };
  },
  methods: {
    async forgot() {
      try {
        let { data, error } = await supabase.auth.resetPasswordForEmail(this.email)

        if (error) {
          console.error(error);
        } else {
          console.log('data:', data);
          this.messa=true

        }
      } catch (error) {
        console.error('Error:', error.message);
      }
    },
  }

};

</script>


<style scoped>
.login-form {
  display: flex;
  flex-direction: column;
  width: 400px;
  /* margin: 2% auto 0; */
  margin: auto 0;
  gap: 5%;
  border: 1px solid grey;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  background: #1a1625;
  align-items: center;
  justify-content: center;
}

.form-container{
  height:100vh;
  width:100vw;
  /* border-top:30px solid transparent; */
  display: flex;
  justify-content: center;
  background: #2f2b3a ;
}


h2 {
  text-align: center;
  color: peachpuff;
}

label {
  /* display: block; */
  margin-bottom: 8px;
  color: #555;
}

input {
  width: 80%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid grey;
  border-radius: 4px;
  text-align: center;
  background: #2f2b3a ;
  color: white;
}

p{
  text-align: left;
  color:whitesmoke;
  font-size: 15px;
}

.signup{
  text-align: center;
  color:grey;
  font-size: 15px;
}

.submit-button {
  width: 80%;
  padding: 10px;
  margin-top:8px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: background-color 0.3s;
  text-align: center;
}





.submit-button{
  width:86%;
  background-color: #ffff99;
  color: #001233;
  border: 1px solid #8f9ba3;
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 20px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}


.submit-button:hover {
  background-color: #d5d58b;
}



.logo {
  width: 70px;
  height: 70px;
  cursor: pointer;
  border-radius: 50%;
}

.hyper-link{
  color:cyan;
}


.top-text{
  width:86%;
  margin-bottom:10%;
}

</style>
